(() => {
  const formatter = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Sydney', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  function stateAt(date) {
    const p = Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]));
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
    const seconds = Number(p.hour) * 3600 + Number(p.minute) * 60 + Number(p.second);
    if (day === 0 || day === 6) return { key: 'tuesday', remaining: 0, weekend: true };
    if (seconds < 43200) return { key: day === 5 ? 'friday_countdown' : 'weekday_countdown', remaining: 43200 - seconds };
    return { key: ['tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'tuesday'][day], remaining: 0 };
  }
  function holidayStateAt(date) {
    const p = Object.fromEntries(formatter.formatToParts(date).map(part => [part.type, part.value]));
    const day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
    const seconds = Number(p.hour) * 3600 + Number(p.minute) * 60 + Number(p.second);
    if (day === 6) return { key: 'saturday_fixed', remaining: 0 };
    if (day === 5) return seconds < 43200 ? { key: 'friday_countdown', remaining: 43200 - seconds } : { key: 'friday_fixed', remaining: 0 };
    const start = Math.floor(date.getTime() / 1000);
    let low = start, high = start + 26 * 3600;
    while (high - low > 1) {
      const middle = Math.floor((low + high) / 2);
      const weekday = formatter.formatToParts(new Date(middle * 1000)).find(part => part.type === 'weekday').value;
      if (weekday === p.weekday) low = middle; else high = middle;
    }
    return { key: ['sunday_countdown', 'monday_countdown', 'tuesday_countdown', 'wednesday_countdown', 'thursday_countdown'][day], remaining: high - start };
  }
  function resolveState(config, date, christmas) {
    let state = config.holidaySchedule ? holidayStateAt(date) : stateAt(date);
    if (christmas && state.weekend) state.key = 'weekend';
    if (!config.holidaySchedule && !christmas && config.publicHoliday) state = state.key === 'friday_countdown'
      ? { key: 'holiday_friday_countdown', remaining: state.remaining }
      : { key: 'public_holiday', remaining: 0 };
    if (!config.holidaySchedule && !christmas && config.override) state = { key: 'override', remaining: 0 };
    if (config.preview && config.preview !== 'auto') state = { key: config.preview, remaining: 9015 };
    return state;
  }
  window.STDDeliverySchedule = { stateAt, holidayStateAt, resolveState };
  let cleanup;
  function init() {
    if (cleanup) cleanup();
    const regular = document.querySelector('[data-std-delivery-banner]:not([data-christmas-banner]):not([data-holiday-banner])');
    const christmas = document.querySelector('[data-christmas-banner]');
    const holiday = document.querySelector('[data-holiday-banner]');
    const elements = [regular, christmas, holiday].filter(Boolean);
    const configs = new Map(elements.map(root => [root, JSON.parse(root.querySelector('[data-banner-config]').textContent)]));
    let activeRoot, lastKey, activeSlide = 0, elapsed = 0, paused = false, hover = false;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const measure = () => document.documentElement.style.setProperty('--std-delivery-height', activeRoot && !activeRoot.hidden ? `${activeRoot.getBoundingClientRect().height}px` : '0px');
    const setSlide = () => {
      if (!christmas) return;
      christmas.classList.toggle('std-christmas-message-active', activeSlide === 1);
      christmas.querySelectorAll('[data-ticker-slide]').forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== activeSlide)));
    };
    const onPause = () => {
      paused = !paused;
      christmas.querySelector('[data-ticker-pause]').setAttribute('aria-pressed', String(paused));
    };
    const onNext = () => { activeSlide = 1 - activeSlide; elapsed = 0; setSlide(); };
    const onEnter = () => { hover = true; };
    const onLeave = () => { hover = false; };
    const onFocusOut = event => { if (!christmas.contains(event.relatedTarget)) hover = false; };
    const tick = () => {
      const xconfig = christmas && configs.get(christmas);
      const hconfig = holiday && configs.get(holiday);
      const useHoliday = hconfig && (hconfig.enabled || hconfig.preview !== 'auto');
      const useChristmas = !useHoliday && xconfig && (xconfig.enabled || xconfig.preview !== 'auto');
      const root = useHoliday ? holiday : useChristmas ? christmas : regular;
      if (!root) { elements.forEach(el => { el.hidden = true; }); activeRoot = null; measure(); return; }
      const config = configs.get(root);
      const state = resolveState(config, new Date(), !!useChristmas);
      const message = config.messages[state.key];
      const visible = (config.enabled || config.preview !== 'auto') && message && message.enabled;
      elements.forEach(el => { el.hidden = el !== root || !visible; });
      const rootChanged = activeRoot !== root;
      activeRoot = root;
      if (!visible) { measure(); return; }
      const isCountdown = state.key.endsWith('countdown');
      const textBefore = root.querySelector('[data-banner-before]');
      const textAfter = root.querySelector('[data-banner-after]');
      const timer = root.querySelector('[data-banner-timer]');
      if (lastKey !== state.key || rootChanged) {
        textBefore.textContent = config.holidaySchedule ? message.text : isCountdown ? config.before : message.text;
        textAfter.textContent = isCountdown ? (config.holidaySchedule ? message.after : message.text) : '';
        textAfter.hidden = !isCountdown;
        timer.hidden = !isCountdown;
        lastKey = state.key;
        activeSlide = state.key === 'christmas_message' ? 1 : 0;
        elapsed = 0;
        setSlide();
      }
      if (isCountdown) {
        const parts = [Math.floor(state.remaining / 3600), Math.floor(state.remaining / 60) % 60, state.remaining % 60];
        root.querySelectorAll('[data-banner-number]').forEach((node, i) => { node.textContent = String(parts[i]).padStart(2, '0'); });
        timer.setAttribute('aria-label', `${parts[0]} ${config.hours}, ${parts[1]} ${config.minutes}, ${parts[2]} ${config.seconds}`);
      }
      if (useChristmas && config.autoRotate && !reduced.matches && !paused && !hover && state.key !== 'christmas_message') {
        elapsed++;
        if (elapsed >= config.interval) { activeSlide = 1 - activeSlide; elapsed = 0; setSlide(); }
      }
      measure();
    };
    const observer = new ResizeObserver(measure);
    elements.forEach(root => observer.observe(root));
    if (christmas) {
      christmas.querySelector('[data-ticker-pause]').addEventListener('click', onPause);
      christmas.querySelector('[data-ticker-next]').addEventListener('click', onNext);
      christmas.addEventListener('pointerenter', onEnter);
      christmas.addEventListener('pointerleave', onLeave);
      christmas.addEventListener('focusin', onEnter);
      christmas.addEventListener('focusout', onFocusOut);
    }
    const interval = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
    tick();
    cleanup = () => {
      clearInterval(interval); observer.disconnect(); document.removeEventListener('visibilitychange', tick);
      if (christmas) {
        christmas.querySelector('[data-ticker-pause]').removeEventListener('click', onPause);
        christmas.querySelector('[data-ticker-next]').removeEventListener('click', onNext);
        christmas.removeEventListener('pointerenter', onEnter); christmas.removeEventListener('pointerleave', onLeave);
        christmas.removeEventListener('focusin', onEnter); christmas.removeEventListener('focusout', onFocusOut);
      }
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', init);
})();
